import http from '@/utils/http';
import i18n from '@/main';

export default {
    findEstados(lockScreen = true) {
        return http.get({
            url: `/estados`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    findMunicipios(estado, lockScreen = true) {
        return http.get({
            url: `/estados/${estado}/municipios`,
            lockMessage: i18n.t(
                'mensagens.sistema.aguardeBuscandoDadosDeMunicipio'
            ),
            lockScreen
        });
    },

    findNivel0(lockScreen = false) {
        return http.get({
            url: `/localidade/nivel0`,
            lockScreen
        });
    },

    findNivel1(idNivel0, lockScreen = true) {
        return http.get({
            url: `localidade/nivel1/${idNivel0}`,
            lockMessage: i18n.t('mensagens.sistema.aguardeBuscandoEstados'),
            lockScreen
        });
    },

    findNivel2(idNivel1, lockScreen = true) {
        return http.get({
            url: `localidade/nivel2/${idNivel1}`,
            lockMessage: i18n.t(
                'mensagens.sistema.aguardeBuscandoDadosDeMunicipio'
            ),
            lockScreen
        });
    }
};
